/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Seo_Extension_TitleInputs */

const he_seo_extension_title = /** @type {(inputs: Seo_Extension_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`תוסף Pricedrop לדפדפן - מעקב מחירים KSP`)
};

const en_seo_extension_title = /** @type {(inputs: Seo_Extension_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pricedrop Browser Extension - KSP Price Tracker`)
};

/**
* | output |
* | --- |
* | "Pricedrop Browser Extension - KSP Price Tracker" |
*
* @param {Seo_Extension_TitleInputs} inputs
* @param {{ locale?: "he" | "en" }} options
* @returns {LocalizedString}
*/
export const seo_extension_title = /** @type {((inputs?: Seo_Extension_TitleInputs, options?: { locale?: "he" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Seo_Extension_TitleInputs, { locale?: "he" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "he") return he_seo_extension_title(inputs)
	return en_seo_extension_title(inputs)
});